<template>
  <div class="property-filter">
    <div class="property-filter__heading">{{ language.code === 'en' ? 'Filter your results by making selections below' : 'ترشيح النتائج عبر الاختيارات أدناه' }}</div>
    <div class="property-filter__inputs">
      <input-radio-select 
        class="property-filter__input"
        :label="language.code === 'en' ? 'Home Type' : 'نوع المنزل'"
        :selections="typeSelections"
        v-model="inputTypes"
        is-vertical="true"
      />
      <input-radio-select 
        class="property-filter__input"
        :label="language.code === 'en' ? 'Bedrooms' : 'غُرْفة النَّوْم'"
        :selections="bedsSelections"
        v-model="inputBeds"
      />
      <input-dropdown 
        class="property-filter__input"
        :label="language.code === 'en' ? 'View' : 'مَنْظَر'"
        :selections="viewSelections"
        v-model="inputView"
        is-vertical="true"
      />
      <input-filter-reset 
        class="property-filter__input"
      />
      <!-- <input-radio-select 
        class="property-filter__input"
        label="Bathrooms"
        :selections="bathsSelections"
        v-model="inputBaths"
      /> -->
      <!-- <input-radio-select 
        class="property-filter__input"
        label="Cars"
        :selections="carsSelections"
        v-model="inputCars"
      /> -->
    </div>
  </div>
</template>
<script>
import InputRadioSelect from './InputRadioSelect'
import InputDropdown from './InputDropdown'
import InputFilterReset from './InputFilterReset'
import { mapGetters } from 'vuex'

export default {
  components: { InputRadioSelect, InputDropdown, InputFilterReset },

  data () {
    return {
      bathsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ],
      bedsSelections: [
        { label: { en: 'Any', ar: 'أَيّ' }, value: false },
        { label: { en: '1', ar: '1' }, value: 1 },
        { label: { en: '2', ar: '2' }, value: 2 },
        { label: { en: '3', ar: '3' }, value: 3 },
        { label: { en: '4+', ar: '4+' }, value: 4 }
      ],
      carsSelections: [
        { label: 'Any', value: false },
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4+', value: 4 },
      ],
      viewSelections: [
        { label: { en: 'All', ar: 'جَميع' }, value: false },
        { label: { en: 'Beach Front', ar: 'Beach Front' }, value: 'Beach Front' },
        // { label: 'Boulevard', value: 'Boulevard' },
        // { label: 'Dry View', value: 'Dry View' },
        // { label: 'Lake', value: 'Lake' },
        { label: { en: 'Marina', ar: 'Marina' }, value: 'Marina' },
        { label: { en: 'Mild View', ar: 'Mild View' }, value: 'Mild View' },
        { label: { en: 'Park', ar: 'Park' }, value: 'Park' },
        // { label: 'Pool', value: 'Pool' },
        { label: { en: 'Standard', ar: 'Standard' }, value: 'Standard' },
        { label: { en: 'Urban', ar: 'Urban' }, value: 'Urban' },
      ]
    }
  },

  computed: {
    ...mapGetters([
      'language'
    ]),

    inputBaths: {
      get () {
        return this.$store.state.property.inputBaths
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputBaths: value
        })
      }
    },

    inputBeds: {
      get () {
        return this.$store.state.property.inputBeds
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputBeds: value
        })
      }
    },

    inputCars: {
      get () {
        return this.$store.state.property.inputCars
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputCars: value
        })
      }
    },

    inputTypes: {
      get () {
        return this.$store.state.property.inputType
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputType: value
        })
      }
    },

    inputView: {
      get () {
        return this.$store.state.property.inputView
      },
      set (value) {
        this.$store.commit('property/SET_FILTER_PARAMETERS', {
          inputView: value
        })
      }
    },

    typeSelections () {
      let selections = [{ 
        label: {
          en: 'All',
          ar: 'جَميع'
        }, 
        value: null 
      }]
      this.$store.getters['property/propertyTypes'].forEach(propertyType => {
        var propertyTypeAr = ''

        if (propertyType === 'apartment') {
          propertyTypeAr = 'الشقق'
        }
        if (propertyType === 'villa') {
          propertyTypeAr = 'الفلل'
        }
        if (propertyType === 'townhome') {
          propertyTypeAr = 'المنازل المدمجة'
        }
        if (propertyType === 'palace') {
          propertyTypeAr = 'القصور'
        }

        var propertyTypeObject = {
          en: propertyType,
          ar: propertyTypeAr
        }
        selections.push({ label: propertyTypeObject, value: propertyType })
      })
      return selections
    }
  }
}
</script>
<style lang="scss">
.property-filter {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__heading {
    font-size: 2rem;
    line-height: 1;
    margin-bottom: 1em;
  }

  &__inputs {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
  }

  &__input {
    margin-bottom: 1rem;
  }
}
</style>